import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { SpaceTabDocumentType } from 'api/space/space-tab';
import { StoreActionProps } from 'data/core';
import { TemplateObjectType, TemplatesAPI } from 'data/templates/api';
import { setupSpaceTabsOnSpaces } from 'data/templates/projects/slices';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import {
  createDocumentTemplateAction,
  CreateDocumentTemplatePayload,
} from '../actions';
import { DocumentTemplate, DocumentTemplateSourceType } from '../types';

function* createDocumentTemplateSaga(
  action: StoreActionProps<CreateDocumentTemplatePayload>,
) {
  const {
    payload: {
      spaceId,
      state,
      templateName,
      handleAlways,
      handleFailure,
      handleSuccess,
    },
  } = action;

  try {
    const template: DocumentTemplate = {
      templateId: 'new',
      templateName,
      templateContent: {
        documentId: floatUid(),
        title: templateName,
        sections: [
          {
            content: '<p></p>',
            documentSectionId: floatUid(),
            meta: {
              sectionType: 'PUBLIC',
              resourceSections: [],
            },
            createdAt: +new Date(),
          },
        ],
      },
      objectType: TemplateObjectType.Document,
      state,
      sourceType: spaceId
        ? DocumentTemplateSourceType.SpaceTab
        : DocumentTemplateSourceType.Default,
    };

    const documentTemplate = yield TemplatesAPI.save<DocumentTemplate>(
      template,
    );

    if (spaceId) {
      yield put(
        setupSpaceTabsOnSpaces({
          spaceTab: {
            spaceTabId: documentTemplate.templateId as number,
            spaceTabTitle: documentTemplate.templateName || '',
            spaceTabType: SpaceTabDocumentType.RocketlaneDocument,
            url: `/templates/${documentTemplate.templateId}`,
          },
          spaceId,
        }),
      );
    }

    if (handleSuccess) {
      handleSuccess(documentTemplate.templateId as number);
    }
  } catch (error) {
    logger.error('an error creating a document template', { error });

    message.error('There was an error creating a document template');

    if (handleFailure) {
      handleFailure();
    }
  }

  if (handleAlways) {
    handleAlways();
  }
}

export function* watchCreateDocumentTemplateSaga(): Generator {
  yield takeLatest(
    createDocumentTemplateAction.type,
    createDocumentTemplateSaga,
  );
}
